import { colors } from "../../styles/theme";

const STATUS_MAP = {
  "pending-download": { label: "Pending", color: colors.info, bg: "rgba(99,102,241,0.10)" },
  uploaded: { label: "Uploaded", color: colors.info, bg: "rgba(99,102,241,0.10)" },
  processing: { label: "Processing", color: colors.warning, bg: "rgba(245,158,11,0.10)" },
  transcribed: { label: "Transcribed", color: colors.success, bg: "rgba(16,185,129,0.10)" },
  "clips-ready": { label: "Ready", color: colors.success, bg: "rgba(16,185,129,0.10)" },
  archived: { label: "Archived", color: colors.textSecondary, bg: "rgba(255,255,255,0.06)" },
  error: { label: "Error", color: colors.danger, bg: "rgba(239,68,68,0.10)" },
};

const PLATFORM_MAP = {
  zoom: { label: "Zoom", color: "#2D8CFF", bg: "rgba(45,140,255,0.10)" },
  "zoom-webinar": { label: "Webinar", color: "#2D8CFF", bg: "rgba(45,140,255,0.10)" },
  "zoom-clip": { label: "Zoom Clip", color: "#2D8CFF", bg: "rgba(45,140,255,0.10)" },
  teams: { label: "Teams", color: "#6264A7", bg: "rgba(98,100,167,0.10)" },
  unknown: { label: "Other", color: colors.textSecondary, bg: "rgba(255,255,255,0.05)" },
};

export function StatusBadge({ status }) {
  const s = STATUS_MAP[status] || STATUS_MAP.uploaded;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 4,
      padding: "3px 10px", borderRadius: 4, fontSize: 11, fontWeight: 600,
      letterSpacing: "0.03em", textTransform: "uppercase",
      color: s.color, backgroundColor: s.bg,
    }}>
      {s.label}
    </span>
  );
}

export function PlatformBadge({ platform }) {
  const p = PLATFORM_MAP[platform] || PLATFORM_MAP.unknown;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 4,
      padding: "3px 10px", borderRadius: 4, fontSize: 11, fontWeight: 600,
      letterSpacing: "0.03em",
      color: p.color, backgroundColor: p.bg,
    }}>
      {p.label}
    </span>
  );
}

export { STATUS_MAP, PLATFORM_MAP };
